var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _vm.aprovalTemplate && _vm.aprovalTemplate.aprobacion
      ? _c(
          "div",
          [
            _c("FlowDetail", { attrs: { readOnly: true } }),
            _c("Observers", { attrs: { readOnly: true } }),
            _vm.aprovalTemplate && _vm.aprovalTemplate.gatillaciones
              ? _c(
                  "b-card",
                  { attrs: { title: "Consecuencias" } },
                  [
                    _c("Consequences", {
                      attrs: {
                        original: _vm.aprovalTemplate.gatillaciones,
                        readOnly: true
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.aprovalTemplate.aprobacion &&
            _vm.aprovalTemplate.aprobacion.tipoEjecucion
              ? _c("Steps", {
                  attrs: {
                    flowType: _vm.aprovalTemplate.aprobacion.tipoEjecucion,
                    readOnly: true
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }